// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"865ef045","513":"ea88b298","703":"aa93f419"}[chunkId] + ".chunk.js";
};